import { inject } from '@angular/core'
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http'
import { throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import { AuthenticationService } from './authentication.service'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router)
  const authService = inject(AuthenticationService)

  // Clone the request and add withCredentials to include cookies in cross-origin requests
  const clonedRequest = req.clone({
    withCredentials: true,
  })

  return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Clear authentication state
        authService.userInfo.next({})

        // Redirect to login page
        router.navigate(['/login'])

        // Return empty observable to prevent error propagation
        return throwError(() => error)
      }

      // Re-throw error for other status codes
      return throwError(() => error)
    }),
  )
}
